export default __webpack_public_path__ + "static/media/Gallery - Clean vs Prince_02.295513db.jpg";